import React from 'react';
import './UserCard.scss';

export type UserCardProps = {
    icon?: React.ReactNode;
    title?: string;
    children: React.ReactNode;
    className?: string;
};

export const UserCard: React.FC<UserCardProps> = ({ icon, title, children, className }) => {
    return (
        <section className={`user-card ${className ?? ''}`}>
            {(icon || title) && (
                <header className="user-card__header">
                    {icon && <span className="user-card__icon" aria-hidden="true">{icon}</span>}
                    {title && <h2 className="user-card__title">{title}</h2>}
                </header>
            )}
            <div className="user-card__body">{children}</div>
        </section>
    );
};
